(() => {
  const initialize = (root) => {
    if (root.dataset.owlReady) return;
    root.dataset.owlReady = 'true';
    const form = root.querySelector('.owl-product-form');
    const mainImage = root.querySelector('.owl-gallery__image');
    const thumbnails = Array.from(root.querySelectorAll('[data-image-src]'));
    const lightbox = root.querySelector('[data-lightbox]');
    const lightboxImage = root.querySelector('[data-lightbox-image]');
    const variants = JSON.parse(root.querySelector('[data-owl-variants]').textContent);
    const sticky = root.querySelector('[data-sticky]');
    const mainButton = root.querySelector('[data-main-add]');
    const quantity = form.querySelector('[name="quantity"]');
    let selectedImage = 0;
    let pointerX = 0;
    let lastSwipe = 0;
    const selectImage = (index, focus = false) => {
      selectedImage = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[selectedImage];
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = thumbnail.dataset.imageSrcset;
      mainImage.alt = thumbnail.dataset.imageAlt;
      if (lightbox.open) {
        lightboxImage.src = thumbnail.dataset.imageSrc;
        lightboxImage.alt = thumbnail.dataset.imageAlt;
      }
      thumbnails.forEach((item, i) => {
        item.classList.toggle('is-active', i === selectedImage);
        item.setAttribute('aria-pressed', String(i === selectedImage));
      });
      if (focus) thumbnail.focus({ preventScroll: true });
    };
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => selectImage(index));
      thumbnail.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          selectImage(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
    });
    const openGallery = root.querySelector('[data-open-gallery]');
    openGallery.addEventListener('click', () => {
      if (Date.now() - lastSwipe < 350) return;
      lightboxImage.src = thumbnails[selectedImage].dataset.imageSrc;
      lightboxImage.alt = mainImage.alt;
      lightbox.showModal();
    });
    openGallery.addEventListener('pointerdown', (event) => { pointerX = event.clientX; });
    openGallery.addEventListener('pointerup', (event) => {
      const distance = event.clientX - pointerX;
      if (Math.abs(distance) > 45) {
        lastSwipe = Date.now();
        selectImage(selectedImage + (distance < 0 ? 1 : -1));
      }
    });
    root.querySelector('[data-close-gallery]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target !== lightbox) return;
      const box = lightbox.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        selectImage(selectedImage + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const syncVariant = () => {
      const chosen = form.querySelector('[name="id"]:checked');
      const variant = variants.find((item) => String(item.id) === chosen?.value);
      if (!variant) return;
      root.querySelector('[data-price]').textContent = variant.price;
      root.querySelector('[data-sticky-price]').textContent = variant.price;
      root.querySelector('[data-sticky-variant]').textContent = variant.title;
      const compare = root.querySelector('[data-compare-price]');
      if (compare) { compare.hidden = !variant.isSale; compare.textContent = variant.comparePrice; }
      const saving = root.querySelector('[data-saving-badge]');
      if (saving) {
        saving.hidden = !variant.isSale || variant.savingPercent < 1;
        saving.textContent = root.dataset.savingLabel.replace('[percent]', String(variant.savingPercent));
      }
      root.querySelectorAll('[data-main-add], [data-sticky-add]').forEach((button) => {
        button.disabled = !variant.available;
        button.querySelector('[data-add-text]').textContent = variant.available ? root.dataset.addLabel : root.dataset.soldLabel;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    form.addEventListener('change', (event) => { if (event.target.name === 'id') syncVariant(); });
    const normalizeQuantity = () => {
      const value = Number.parseInt(quantity.value, 10);
      quantity.value = Number.isFinite(value) && value > 0 ? value : 1;
    };
    quantity.addEventListener('change', normalizeQuantity);
    root.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        normalizeQuantity();
        quantity.value = Math.max(1, Number(quantity.value) + Number(button.dataset.quantityChange));
      });
    });
    form.addEventListener('submit', () => {
      normalizeQuantity();
      root.querySelectorAll('[data-main-add], [data-sticky-add]').forEach((button) => {
        button.disabled = true;
        button.querySelector('[data-add-text]').textContent = root.dataset.busyLabel;
      });
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: 0.25 });
      observer.observe(mainButton);
    }
    window.addEventListener('pageshow', syncVariant);
    syncVariant();
  };
  const initializeAll = (container = document) => container.querySelectorAll('[data-owl-model]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.querySelectorAll('.owl-navigation').forEach((menu) => {
    document.addEventListener('click', (event) => { if (!menu.contains(event.target)) menu.open = false; });
    menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  });
})();